export default [
    {
        id: 1,
        title: '台捷精密股份有限公司',
        registerInstitution: '台捷精密股份有限公司',
        taxId: '54107606',
        unitPublishNumber: '(110)台捷建海標字第2021121301號',
        epaPublishNumber: '環署基字第1100079152號',
        validDateRange: '110.12.21-113.12.21',
        status: 'Valid',
        created: '2022-11-21T12:01:22.94',
        products: [
            { id: 1, name: '海捷晶粒料', model: 'Tj-SPBA501515', weightRate: 25.0 },
            { id: 2, name: '角材3*3*270', model: '3*3/SRpet-WPC', weightRate: 21.93 },
            { id: 3, name: '板材1.5*9*250', model: '1.5*9/SRpet-WPC', weightRate: 21.93 },
            { id: 4, name: '模組拼接地板45*45*4.5', model: '3*3*3支+1.5*9*5片/SRpet-WPC', weightRate: 21.67 },
        ],
    },
    {
        id: 2,
        title: '宏恩塑膠股份有限公司',
        registerInstitution: '宏恩塑膠股份有限公司',
        taxId: '86806053',
        unitPublishNumber: '恩總字第20211101001號',
        epaPublishNumber: '環署基字1101156393號',
        validDateRange: '110.11.16-113.11.16',
        status: 'Valid',
        created: '2022-11-21T12:03:35.543',
        products: [
            { id: 5, name: '海廢PP塑膠再生料', model: 'OB-PP-100', weightRate: 100.0 },
            { id: 6, name: '海廢PE塑膠再生料', model: 'OB-PE-100', weightRate: 100.0 },
            { id: 7, name: '海廢PA塑膠再生料', model: 'OB-PA-100', weightRate: 100.0 },
            { id: 8, name: '海廢ABS塑膠再生料', model: 'OB-ABS-100', weightRate: 100.0 },
            { id: 9, name: '海廢PS塑膠再生料', model: 'OB-PS-100', weightRate: 100.0 },
        ],
    },
    {
        id: 3,
        title: '寶綠特資源再生科技股份有限公司',
        registerInstitution: '寶綠特資源再生科技股份有限公司',
        taxId: '64978460',
        unitPublishNumber: '寶字第1101102001號',
        epaPublishNumber: '環署基字1101159293號',
        validDateRange: '110.11.18-113.11.18',
        status: 'Valid',
        created: '2022-11-21T12:04:48.59',
        products: [
            { id: 10, name: '海廢PET破碎瓶片', model: '04WW-O/PET', weightRate: 100.0 },
            { id: 11, name: '海廢PET瓶粒', model: '06WW-O/PET', weightRate: 50.0 },
            { id: 12, name: '海廢PP破碎瓶片', model: 'PP-O', weightRate: 100.0 },
        ],
    },
    {
        id: 4,
        title: '耐斯企業股份有限公司',
        registerInstitution: '耐斯企業股份有限公司',
        taxId: '65408770',
        unitPublishNumber: '耐鴻字第110079號',
        epaPublishNumber: '環署基字第1100078517號',
        validDateRange: '110.12.15-113.12.15',
        status: 'Valid',
        created: '2022-11-21T12:05:53.663',
        products: [{ id: 13, name: '白鴿漂白素瓶身', model: 'PE-23/PE', weightRate: 26.0 }],
    },
    {
        id: 5,
        title: '海神全球股份有限公司',
        registerInstitution: '海神全球股份有限公司',
        taxId: '69758198',
        unitPublishNumber: '111101201',
        epaPublishNumber: '環署基字第1110068866號',
        validDateRange: '-',
        status: 'Invalid',
        created: '2022-11-21T12:08:27.173',
        products: [{ id: 14, name: 'PSD超低硫燃料油', model: 'P001', weightRate: 39.23 }],
    },
    {
        id: 6,
        title: '海神全球股份有限公司',
        registerInstitution: '海神全球股份有限公司',
        taxId: '69758198',
        unitPublishNumber: '111101201',
        epaPublishNumber: '環署基字第1110068866號',
        validDateRange: '110.10.28-114.10.28',
        status: 'Valid',
        created: '2022-11-21T12:08:55.777',
        products: [{ id: 15, name: 'PSD再生碳', model: 'P002', weightRate: 39.23 }],
    },
    {
        id: 7,
        title: '綠藤生物科技股份有限公司',
        registerInstitution: '綠藤生物科技股份有限公司',
        taxId: '29142083',
        unitPublishNumber: '未具文號',
        epaPublishNumber: '環署基字第1110069249號',
        validDateRange: '110.10.25-114.10.25',
        status: 'Valid',
        created: '2022-11-21T12:09:38.79',
        products: [{ id: 16, name: '綠藤生機海廢瓶器', model: '42012-9106', weightRate: 33.0 }],
    },
    {
        id: 8,
        title: '寶綠特資源再生科技股份有限公司',
        registerInstitution: '寶綠特資源再生科技股份有限公司',
        taxId: '64978460',
        unitPublishNumber: '寶(管)字第1111018001號',
        epaPublishNumber: '環署基字第1110069906號',
        validDateRange: '110.10.25-114.10.25',
        status: 'Valid',
        created: '2022-11-21T12:11:29.183',
        products: [
            { id: 17, name: '海廢PET破碎瓶片', model: '04WW-O/PET', weightRate: 100.0 },
            { id: 18, name: '海廢PET瓶粒', model: '06WW-O/PET', weightRate: 50.0 },
            { id: 19, name: '海廢PP破碎瓶片', model: 'PP-O', weightRate: 100.0 },
        ],
    },
    {
        id: 9,
        title: '豐溢綠能材料股份有限公司',
        registerInstitution: '豐溢綠能材料股份有限公司',
        taxId: '90732456',
        unitPublishNumber: '豐材環字第1120601001號',
        epaPublishNumber: '環署基字第1120027071號',
        validDateRange: '112.06.21-115.06.21',
        status: 'Valid',
        created: '2023-09-04T14:58:15.107',
        products: [
            { id: 20, name: '100%海廢保麗龍再生粒子', model: '3SA-B03', weightRate: 100.0 },
            { id: 21, name: '100%海廢 PE漁網再生粒子', model: '3EA-B01', weightRate: 100.0 },
        ],
    },
]
